'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

// This function can be defined here or imported if used elsewhere
const pageview = (url: string) => {
  if (typeof window.dataLayer !== 'undefined') {
    window.dataLayer.push({
      event: 'pageview',
      page: url,
    });
  }
};

export function GtmAnalytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Combine pathname and searchParams to form the full URL
    const url = pathname + searchParams.toString();
    pageview(url);
  }, [pathname, searchParams]);

  // This component does not render anything to the DOM
  return null;
}
